// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.race-results-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 12px;
}

.race-results-modal {
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 8px;
  width: 100%;
  max-width: 1000px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #334155;
  gap: 20px;
  flex-shrink: 0;
}

.modal-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-title {
  flex: 1 1;
}

.modal-title h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.session-info {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #94a3b8;
}

.track-name,
.server-name,
.lap-info {
  display: flex;
  align-items: center;
}

.track-name::before {
  content: '📍 ';
  margin-right: 6px;
}

.server-name::before {
  content: '🖥️ ';
  margin-right: 6px;
}

.lap-info::before {
  content: '🏁 ';
  margin-right: 6px;
}

.close-button {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  flex-shrink: 0;
}

.close-button:hover {
  color: #cbd5e1;
}

.results-table-container {
  flex: 1 1;
  overflow: auto;
  min-height: 0;
}

.penalty-summary-bar {
  padding: 12px 20px;
  background-color: #112e4a;
  border-bottom: 1px solid #334155;
  color: #cbd5e1;
  font-size: 13px;
  flex-shrink: 0;
}

.penalty-value {
  color: #fda4af;
  font-weight: 700;
}

/* Desktop: Table Layout */
.results-standings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.results-standings-table thead {
  background-color: #1e293b;
  position: sticky;
  top: 0;
  z-index: 10;
}

.results-standings-table th {
  padding: 14px 12px;
  text-align: left;
  font-weight: 600;
  color: #cbd5e1;
  border-bottom: 1px solid #334155;
  -webkit-user-select: none;
          user-select: none;
}

.results-standings-table tbody tr {
  border-bottom: 1px solid #334155;
  transition: background-color 0.2s;
}

.results-standings-table tbody tr:hover {
  background-color: #334155;
}

.results-standings-table tbody tr.winner {
  background-color: rgba(34, 197, 94, 0.1);
}

.results-standings-table tbody tr.winner:hover {
  background-color: rgba(34, 197, 94, 0.2);
}

.results-standings-table tbody tr.best-lap {
  background-color: rgba(168, 85, 247, 0.1);
}

.results-standings-table tbody tr.best-lap:hover {
  background-color: rgba(168, 85, 247, 0.15);
}

.results-standings-table td {
  padding: 12px;
  color: #e2e8f0;
}

.col-position {
  width: 50px;
  text-align: center;
}

.col-driver {
  width: auto;
  flex: 1 1;
  min-width: 150px;
}

.col-driver .driver-name .driverPos {
    display: none;
}

.col-car {
  width: auto;
  flex: 1 1;
  min-width: 180px;
}

.col-number {
  width: 50px;
  text-align: center;
}

.col-best {
  width: 100px;
  text-align: right;
  font-family: 'Courier New', monospace;
}

.col-time {
  width: 100px;
  text-align: right;
  font-family: 'Courier New', monospace;
}

.col-time .penalty-info {
  display: none;
}

.col-penalty {
  width: 140px;
  text-align: left;
  font-family: 'Courier New', monospace;
}

.col-laps {
  width: 60px;
  text-align: center;
}

.col-gap {
  width: 120px;
  text-align: right;
  font-family: 'Courier New', monospace;
}

.penalty-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.penalty-info {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background-color: rgba(148, 163, 184, 0.12);
  color: #cbd5e1;
  cursor: help;
}

.penalty-info:hover,
.penalty-info:focus-visible {
  background-color: rgba(148, 163, 184, 0.2);
}

.penalty-tooltip {
  display: none;
  position: absolute;
  top: -100%;
  left: 50%;
  transform: translateX(-50%);
  min-width: 200px;
  max-width: 280px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: rgba(15, 23, 42, 0.96);
  color: #e2e8f0;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-wrap;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.45);
  z-index: 5;
}

.penalty-info:hover .penalty-tooltip,
.penalty-info:focus-visible .penalty-tooltip {
  display: block;
}

.no-penalty {
  color: #94a3b8;
}

.race-results-modal .position-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  box-shadow: 0 2px 6px rgba(2, 6, 23, 0.6);
}

.race-results-modal .results-standings-table tbody tr.winner .position-badge {
  background-color: #22c55e;
}

.driver-name-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.driver-name {
  font-weight: 500;
  color: #f1f5f9;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.position-change {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 999px;
  min-width: 28px;
  height: 24px;
  justify-content: center;
}

.position-change.gain {
  color: #22c55e;
  background-color: rgba(34, 197, 94, 0.12);
}

.position-change.loss {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.12);
}

.position-change.equal {
  color: #f59e0b;
  background-color: rgba(245, 158, 11, 0.08);
}

.position-change .equal-mark {
  display: inline-block;
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  font-weight: 700;
}

.car-model {
  color: #cbd5e1;
  font-size: 13px;
}

.col-driver .car-model {
    display: none;
}

.race-results-modal .race-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 28px;
  padding: 0 6px;
  background-color: #111827;
  border-radius: 6px;
  font-weight: 700;
  color: #e2e8f0;
  font-size: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.lap-best {
  color: #cbd5e1;
  font-weight: 500;
}

.lap-best.best {
  color: #c084fc;
  font-weight: 700;
}

.lap-time {
  color: #cbd5e1;
  font-weight: 500;
}

.lap-count {
  color: #cbd5e1;
  font-weight: 600;
  font-size: 14px;
}

.gap {
  color: #94a3b8;
}

.gap.leader {
  color: #22c55e;
  font-weight: 600;
}

.lap-details-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(2, 6, 23, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1100;
}

.lap-details-modal {
  width: min(920px, 100%);
  max-height: 80vh;
  overflow: hidden;
  background-color: #111827;
  border: 1px solid #334155;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(2, 6, 23, 0.7);
}

.lap-details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid #334155;
}

.lap-details-header h3 {
  margin: 0 0 6px;
  color: #f8fafc;
}

.lap-details-header p {
  margin: 0;
  color: #94a3b8;
  font-size: 13px;
}

.lap-details-table-wrapper {
  overflow: auto;
  max-height: calc(80vh - 90px);
}

.lap-details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.lap-details-table thead {
  background-color: #1f2937;
  position: sticky;
  top: 0;
  z-index: 1;
}

.lap-details-table th,
.lap-details-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #334155;
}

.lap-details-table th {
  color: #cbd5e1;
  font-weight: 600;
}

.lap-details-table td {
  color: #e2e8f0;
}

.lap-details-table tbody tr:hover {
  background-color: rgba(51, 65, 85, 0.35);
}

.lap-details-table .lap-row-invalid {
  color: #fda4af;
}

.lap-value.best-so-far {
  color: #4ade80;
  font-weight: 700;
}

.lap-value.overall-best {
  color: #c084fc;
  font-weight: 700;
}

.lap-value.invalid {
  color: #fda4af;
  font-weight: 700;
}

.lap-details-empty {
  padding: 24px 20px;
  color: #cbd5e1;
  text-align: center;
}

.lap-details-empty.error {
  color: #fda4af;
}

.error-message {
  padding: 20px;
  background-color: #7f1d1d;
  border: 1px solid #dc2626;
  border-radius: 4px;
  color: #fecaca;
  font-size: 14px;
  text-align: center;
}

/* Scrollbar styling */
.results-table-container::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.results-table-container::-webkit-scrollbar-track {
  background-color: #1e293b;
}

.results-table-container::-webkit-scrollbar-thumb {
  background-color: #475569;
  border-radius: 4px;
}

.results-table-container::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}

/* ─── Tab bar ────────────────────────────────────────────────────────────── */

.results-tab-bar {
  display: flex;
  gap: 2px;
  padding: 0 20px;
  border-bottom: 1px solid #334155;
  background-color: #0f172a;
  flex-shrink: 0;
}

.results-tab {
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: #94a3b8;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  padding: 10px 16px;
  margin-bottom: -1px;
  transition: color 0.15s, border-color 0.15s;
}

.results-tab:hover { color: #cbd5e1; }
.results-tab.active {
  color: #f1f5f9;
  border-bottom-color: #3b82f6;
}

/* ─── Progression tab ────────────────────────────────────────────────────── */

.progression-tab-content {
  flex: 1 1;
  overflow: auto;
  min-height: 0;
  padding: 16px 20px;
}

.progression-chart-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.progression-svg {
  width: 100%;
  height: auto;
  background-color: rgba(15, 23, 42, 0.6);
  border-radius: 8px;
  border: 1px solid #1e293b;
}

.chart-axis-label {
  font-size: 10px;
  fill: #64748b;
  font-family: 'Courier New', monospace;
}

.chart-axis-label-grid {
  fill: #475569;
  font-style: italic;
}

.progression-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.progression-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background-color: rgba(30, 41, 59, 0.7);
  border: 1px solid rgba(51, 65, 85, 0.6);
  color: #cbd5e1;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.15s, background-color 0.15s;
}

.progression-legend-item:hover {
  background-color: rgba(51, 65, 85, 0.8);
}

.progression-legend-item.hidden {
  opacity: 0.45;
}

.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background 0.15s;
}

/* ─── Flag icons ─────────────────────────────────────────────────────────── */

.lap-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  align-items: center;
}

.flag-icon {
  display: inline-block;
  width: 16px;
  height: 11px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}

/* Checkered: alternating black/white squares */
.flag-checkered {
  background: repeating-conic-gradient(#111 0% 25%, #e2e8f0 0% 50%) 0 0 / 8px 6px !important;
}

/* Black/White: diagonal split — top-left black, bottom-right white */
.flag-black-white {
  background: linear-gradient(135deg, #111 50%, #e2e8f0 50%) !important;
}

/* Orange Circle: black base with a centred orange dot */
.flag-orange-circle {
  background: #111 !important;
  position: relative;
}
.flag-orange-circle::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  width: 7px;
  height: 7px;
  background: #f97316;
  margin: auto;
}

/* Red/Yellow Stripes: vertical alternating stripes */
.flag-red-yellow-stripes {
  background: repeating-linear-gradient(
    to right,
    #ef4444 0px, #ef4444 4px,
    #eab308 4px, #eab308 8px
  ) !important;
}

/* Pit stop: white card with black "P" (dark mode default) */
.flag-pitstop {
  background: #e2e8f0 !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.flag-pitstop::after {
  content: 'P';
  position: absolute;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  color: #111;
  font-family: sans-serif;
}

body.light-theme .flag-pitstop {
  background: #1e293b !important;
}
body.light-theme .flag-pitstop::after {
  color: #f8fafc;
}

/* ─── Collision badges ───────────────────────────────────────────────────── */

.lap-events {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.collision-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: default;
}

.collision-badge.collision-damage {
  background-color: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.collision-badge.collision-no-damage {
  background-color: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
  border: 1px solid rgba(245, 158, 11, 0.25);
}

/* ─── Ingame penalty badges ──────────────────────────────────────────────── */

.ingame-penalty-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: default;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ingame-penalty-badge.pending {
  background-color: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.28);
}

.ingame-penalty-badge.cleared {
  background-color: rgba(148, 163, 184, 0.12);
  color: #94a3b8;
  border: 1px solid rgba(148, 163, 184, 0.18);
}

/* Mobile: same table layout as desktop, with horizontal scroll */
@media (max-width: 768px) {
  .race-results-modal {
    max-width: 100%;
    width: 100%;
    max-height: 95vh;
    margin: 8px;
  }

  .modal-header {
    padding: 12px 16px;
  }

  .modal-title h2 {
    font-size: 18px;
    margin: 0 0 4px 0;
  }

  .session-info {
    flex-direction: column;
    gap: 2px;
    font-size: 11px;
  }

  .track-name::before {
    content: '📍 ';
    margin-right: 2px;
  }

  .server-name::before {
    content: '🖥️ ';
    margin-right: 2px;
  }

  .results-table-container {
    padding: 0;
    overflow-x: auto;
  }

  .results-standings-table {
    min-width: 600px;
    font-size: 13px;
  }
}

/* ─── Light-theme overrides ──────────────────────────────────────────────────── */

body.light-theme .race-results-modal {
  background-color: var(--surface);
  border-color: var(--border);
  box-shadow: var(--card-shadow);
}

body.light-theme .modal-header {
  border-bottom-color: var(--border);
}

body.light-theme .modal-title h2 {
  color: var(--text);
}

body.light-theme .session-info {
  color: var(--muted);
}

body.light-theme .close-button {
  color: var(--muted);
}

body.light-theme .close-button:hover {
  color: var(--muted-strong);
}

body.light-theme .penalty-summary-bar {
  background-color: #e0f0ff;
  border-bottom-color: var(--border);
  color: var(--muted-strong);
}

body.light-theme .results-standings-table thead {
  background-color: var(--surface-strong);
}

body.light-theme .results-standings-table th {
  color: var(--muted-strong);
  border-bottom-color: var(--border);
}

body.light-theme .results-standings-table tbody tr {
  border-bottom-color: var(--border);
}

body.light-theme .results-standings-table tbody tr:hover {
  background-color: rgba(15, 23, 42, 0.05);
}

body.light-theme .results-standings-table td {
  color: var(--text);
}

body.light-theme .driver-name {
  color: var(--text);
}

body.light-theme .car-model {
  color: var(--muted);
}

body.light-theme .lap-best,
body.light-theme .lap-time,
body.light-theme .lap-count {
  color: var(--muted-strong);
}

body.light-theme .gap {
  color: var(--muted);
}

body.light-theme .results-tab-bar {
  background-color: var(--surface-strong);
  border-bottom-color: var(--border);
}

body.light-theme .results-tab {
  color: var(--muted);
}

body.light-theme .results-tab:hover {
  color: var(--muted-strong);
}

body.light-theme .results-tab.active {
  color: var(--text);
}

body.light-theme .race-results-modal .race-number {
  background-color: var(--surface-strong);
  color: var(--text);
  border-color: var(--border);
}

body.light-theme .lap-details-modal {
  background-color: var(--surface);
  border-color: var(--border);
}

body.light-theme .lap-details-header {
  border-bottom-color: var(--border);
}

body.light-theme .lap-details-header h3 {
  color: var(--text);
}

body.light-theme .lap-details-header p {
  color: var(--muted);
}

body.light-theme .lap-details-table thead {
  background-color: var(--surface-strong);
}

body.light-theme .lap-details-table th,
body.light-theme .lap-details-table td {
  border-bottom-color: var(--border);
}

body.light-theme .lap-details-table th {
  color: var(--muted-strong);
}

body.light-theme .lap-details-table td {
  color: var(--text);
}

body.light-theme .lap-details-table tbody tr:hover {
  background-color: rgba(15, 23, 42, 0.04);
}

body.light-theme .lap-details-empty {
  color: var(--muted-strong);
}

body.light-theme .no-penalty {
  color: var(--muted);
}

body.light-theme .progression-svg {
  background-color: var(--surface-strong);
  border-color: var(--border);
}

body.light-theme .progression-legend-item {
  background-color: var(--surface-strong);
  border-color: var(--border);
  color: var(--muted-strong);
}

body.light-theme .progression-legend-item:hover {
  background-color: var(--border);
}

body.light-theme .results-table-container::-webkit-scrollbar-track {
  background-color: var(--surface-strong);
}

body.light-theme .results-table-container::-webkit-scrollbar-thumb {
  background-color: var(--border);
}

body.light-theme .results-table-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--muted);
}

`, "",{"version":3,"sources":["webpack://./src/components/RaceResultsViewer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C;;cAEY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,qBAAqB,cAAc,EAAE;AACrC;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,+EAA+E;;AAE/E;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;EACvC,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,0FAA0F;AAC5F;;AAEA,qEAAqE;AACrE;EACE,qEAAqE;AACvE;;AAEA,wDAAwD;AACxD;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE;;;;cAIY;AACd;;AAEA,4DAA4D;AAC5D;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,0CAA0C;AAC5C;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,2CAA2C;AAC7C;;AAEA,iEAAiE;AACjE;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,mFAAmF;;AAEnF;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".race-results-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 12px;\r\n}\r\n\r\n.race-results-modal {\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  max-width: 1000px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #334155;\r\n  gap: 20px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.modal-title {\r\n  flex: 1;\r\n}\r\n\r\n.modal-title h2 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.session-info {\r\n  display: flex;\r\n  gap: 16px;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.track-name,\r\n.server-name,\r\n.lap-info {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.track-name::before {\r\n  content: '📍 ';\r\n  margin-right: 6px;\r\n}\r\n\r\n.server-name::before {\r\n  content: '🖥️ ';\r\n  margin-right: 6px;\r\n}\r\n\r\n.lap-info::before {\r\n  content: '🏁 ';\r\n  margin-right: 6px;\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  color: #94a3b8;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.close-button:hover {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.results-table-container {\r\n  flex: 1;\r\n  overflow: auto;\r\n  min-height: 0;\r\n}\r\n\r\n.penalty-summary-bar {\r\n  padding: 12px 20px;\r\n  background-color: #112e4a;\r\n  border-bottom: 1px solid #334155;\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.penalty-value {\r\n  color: #fda4af;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Desktop: Table Layout */\r\n.results-standings-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.results-standings-table thead {\r\n  background-color: #1e293b;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.results-standings-table th {\r\n  padding: 14px 12px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  border-bottom: 1px solid #334155;\r\n  user-select: none;\r\n}\r\n\r\n.results-standings-table tbody tr {\r\n  border-bottom: 1px solid #334155;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.results-standings-table tbody tr:hover {\r\n  background-color: #334155;\r\n}\r\n\r\n.results-standings-table tbody tr.winner {\r\n  background-color: rgba(34, 197, 94, 0.1);\r\n}\r\n\r\n.results-standings-table tbody tr.winner:hover {\r\n  background-color: rgba(34, 197, 94, 0.2);\r\n}\r\n\r\n.results-standings-table tbody tr.best-lap {\r\n  background-color: rgba(168, 85, 247, 0.1);\r\n}\r\n\r\n.results-standings-table tbody tr.best-lap:hover {\r\n  background-color: rgba(168, 85, 247, 0.15);\r\n}\r\n\r\n.results-standings-table td {\r\n  padding: 12px;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.col-position {\r\n  width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.col-driver {\r\n  width: auto;\r\n  flex: 1;\r\n  min-width: 150px;\r\n}\r\n\r\n.col-driver .driver-name .driverPos {\r\n    display: none;\r\n}\r\n\r\n.col-car {\r\n  width: auto;\r\n  flex: 1;\r\n  min-width: 180px;\r\n}\r\n\r\n.col-number {\r\n  width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.col-best {\r\n  width: 100px;\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.col-time {\r\n  width: 100px;\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.col-time .penalty-info {\r\n  display: none;\r\n}\r\n\r\n.col-penalty {\r\n  width: 140px;\r\n  text-align: left;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.col-laps {\r\n  width: 60px;\r\n  text-align: center;\r\n}\r\n\r\n.col-gap {\r\n  width: 120px;\r\n  text-align: right;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.penalty-cell {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.penalty-info {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 999px;\r\n  background-color: rgba(148, 163, 184, 0.12);\r\n  color: #cbd5e1;\r\n  cursor: help;\r\n}\r\n\r\n.penalty-info:hover,\r\n.penalty-info:focus-visible {\r\n  background-color: rgba(148, 163, 184, 0.2);\r\n}\r\n\r\n.penalty-tooltip {\r\n  display: none;\r\n  position: absolute;\r\n  top: -100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  min-width: 200px;\r\n  max-width: 280px;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  background-color: rgba(15, 23, 42, 0.96);\r\n  color: #e2e8f0;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n  white-space: pre-wrap;\r\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.45);\r\n  z-index: 5;\r\n}\r\n\r\n.penalty-info:hover .penalty-tooltip,\r\n.penalty-info:focus-visible .penalty-tooltip {\r\n  display: block;\r\n}\r\n\r\n.no-penalty {\r\n  color: #94a3b8;\r\n}\r\n\r\n.race-results-modal .position-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  background-color: #3b82f6;\r\n  color: #ffffff;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  box-shadow: 0 2px 6px rgba(2, 6, 23, 0.6);\r\n}\r\n\r\n.race-results-modal .results-standings-table tbody tr.winner .position-badge {\r\n  background-color: #22c55e;\r\n}\r\n\r\n.driver-name-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n}\r\n\r\n.driver-name {\r\n  font-weight: 500;\r\n  color: #f1f5f9;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  min-width: 0;\r\n}\r\n\r\n.position-change {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  padding: 2px 6px;\r\n  border-radius: 999px;\r\n  min-width: 28px;\r\n  height: 24px;\r\n  justify-content: center;\r\n}\r\n\r\n.position-change.gain {\r\n  color: #22c55e;\r\n  background-color: rgba(34, 197, 94, 0.12);\r\n}\r\n\r\n.position-change.loss {\r\n  color: #ef4444;\r\n  background-color: rgba(239, 68, 68, 0.12);\r\n}\r\n\r\n.position-change.equal {\r\n  color: #f59e0b;\r\n  background-color: rgba(245, 158, 11, 0.08);\r\n}\r\n\r\n.position-change .equal-mark {\r\n  display: inline-block;\r\n  width: 12px;\r\n  height: 12px;\r\n  line-height: 12px;\r\n  text-align: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.car-model {\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n}\r\n\r\n.col-driver .car-model {\r\n    display: none;\r\n}\r\n\r\n.race-results-modal .race-number {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 30px;\r\n  height: 28px;\r\n  padding: 0 6px;\r\n  background-color: #111827;\r\n  border-radius: 6px;\r\n  font-weight: 700;\r\n  color: #e2e8f0;\r\n  font-size: 12px;\r\n  border: 1px solid rgba(255, 255, 255, 0.04);\r\n}\r\n\r\n.lap-best {\r\n  color: #cbd5e1;\r\n  font-weight: 500;\r\n}\r\n\r\n.lap-best.best {\r\n  color: #c084fc;\r\n  font-weight: 700;\r\n}\r\n\r\n.lap-time {\r\n  color: #cbd5e1;\r\n  font-weight: 500;\r\n}\r\n\r\n.lap-count {\r\n  color: #cbd5e1;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.gap {\r\n  color: #94a3b8;\r\n}\r\n\r\n.gap.leader {\r\n  color: #22c55e;\r\n  font-weight: 600;\r\n}\r\n\r\n.lap-details-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background-color: rgba(2, 6, 23, 0.82);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  z-index: 1100;\r\n}\r\n\r\n.lap-details-modal {\r\n  width: min(920px, 100%);\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  background-color: #111827;\r\n  border: 1px solid #334155;\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 60px rgba(2, 6, 23, 0.7);\r\n}\r\n\r\n.lap-details-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding: 18px 20px;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.lap-details-header h3 {\r\n  margin: 0 0 6px;\r\n  color: #f8fafc;\r\n}\r\n\r\n.lap-details-header p {\r\n  margin: 0;\r\n  color: #94a3b8;\r\n  font-size: 13px;\r\n}\r\n\r\n.lap-details-table-wrapper {\r\n  overflow: auto;\r\n  max-height: calc(80vh - 90px);\r\n}\r\n\r\n.lap-details-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 13px;\r\n}\r\n\r\n.lap-details-table thead {\r\n  background-color: #1f2937;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.lap-details-table th,\r\n.lap-details-table td {\r\n  padding: 10px 12px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.lap-details-table th {\r\n  color: #cbd5e1;\r\n  font-weight: 600;\r\n}\r\n\r\n.lap-details-table td {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.lap-details-table tbody tr:hover {\r\n  background-color: rgba(51, 65, 85, 0.35);\r\n}\r\n\r\n.lap-details-table .lap-row-invalid {\r\n  color: #fda4af;\r\n}\r\n\r\n.lap-value.best-so-far {\r\n  color: #4ade80;\r\n  font-weight: 700;\r\n}\r\n\r\n.lap-value.overall-best {\r\n  color: #c084fc;\r\n  font-weight: 700;\r\n}\r\n\r\n.lap-value.invalid {\r\n  color: #fda4af;\r\n  font-weight: 700;\r\n}\r\n\r\n.lap-details-empty {\r\n  padding: 24px 20px;\r\n  color: #cbd5e1;\r\n  text-align: center;\r\n}\r\n\r\n.lap-details-empty.error {\r\n  color: #fda4af;\r\n}\r\n\r\n.error-message {\r\n  padding: 20px;\r\n  background-color: #7f1d1d;\r\n  border: 1px solid #dc2626;\r\n  border-radius: 4px;\r\n  color: #fecaca;\r\n  font-size: 14px;\r\n  text-align: center;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.results-table-container::-webkit-scrollbar {\r\n  height: 8px;\r\n  width: 8px;\r\n}\r\n\r\n.results-table-container::-webkit-scrollbar-track {\r\n  background-color: #1e293b;\r\n}\r\n\r\n.results-table-container::-webkit-scrollbar-thumb {\r\n  background-color: #475569;\r\n  border-radius: 4px;\r\n}\r\n\r\n.results-table-container::-webkit-scrollbar-thumb:hover {\r\n  background-color: #64748b;\r\n}\r\n\r\n/* ─── Tab bar ────────────────────────────────────────────────────────────── */\r\n\r\n.results-tab-bar {\r\n  display: flex;\r\n  gap: 2px;\r\n  padding: 0 20px;\r\n  border-bottom: 1px solid #334155;\r\n  background-color: #0f172a;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.results-tab {\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 3px solid transparent;\r\n  color: #94a3b8;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  padding: 10px 16px;\r\n  margin-bottom: -1px;\r\n  transition: color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.results-tab:hover { color: #cbd5e1; }\r\n.results-tab.active {\r\n  color: #f1f5f9;\r\n  border-bottom-color: #3b82f6;\r\n}\r\n\r\n/* ─── Progression tab ────────────────────────────────────────────────────── */\r\n\r\n.progression-tab-content {\r\n  flex: 1;\r\n  overflow: auto;\r\n  min-height: 0;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.progression-chart-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.progression-svg {\r\n  width: 100%;\r\n  height: auto;\r\n  background-color: rgba(15, 23, 42, 0.6);\r\n  border-radius: 8px;\r\n  border: 1px solid #1e293b;\r\n}\r\n\r\n.chart-axis-label {\r\n  font-size: 10px;\r\n  fill: #64748b;\r\n  font-family: 'Courier New', monospace;\r\n}\r\n\r\n.chart-axis-label-grid {\r\n  fill: #475569;\r\n  font-style: italic;\r\n}\r\n\r\n.progression-legend {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n.progression-legend-item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  background-color: rgba(30, 41, 59, 0.7);\r\n  border: 1px solid rgba(51, 65, 85, 0.6);\r\n  color: #cbd5e1;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s, background-color 0.15s;\r\n}\r\n\r\n.progression-legend-item:hover {\r\n  background-color: rgba(51, 65, 85, 0.8);\r\n}\r\n\r\n.progression-legend-item.hidden {\r\n  opacity: 0.45;\r\n}\r\n\r\n.legend-dot {\r\n  display: inline-block;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  transition: background 0.15s;\r\n}\r\n\r\n/* ─── Flag icons ─────────────────────────────────────────────────────────── */\r\n\r\n.lap-flags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 3px;\r\n  align-items: center;\r\n}\r\n\r\n.flag-icon {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 11px;\r\n  border-radius: 2px;\r\n  border: 1px solid rgba(0, 0, 0, 0.3);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Checkered: alternating black/white squares */\r\n.flag-checkered {\r\n  background: repeating-conic-gradient(#111 0% 25%, #e2e8f0 0% 50%) 0 0 / 8px 6px !important;\r\n}\r\n\r\n/* Black/White: diagonal split — top-left black, bottom-right white */\r\n.flag-black-white {\r\n  background: linear-gradient(135deg, #111 50%, #e2e8f0 50%) !important;\r\n}\r\n\r\n/* Orange Circle: black base with a centred orange dot */\r\n.flag-orange-circle {\r\n  background: #111 !important;\r\n  position: relative;\r\n}\r\n.flag-orange-circle::after {\r\n  content: '';\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: 50%;\r\n  width: 7px;\r\n  height: 7px;\r\n  background: #f97316;\r\n  margin: auto;\r\n}\r\n\r\n/* Red/Yellow Stripes: vertical alternating stripes */\r\n.flag-red-yellow-stripes {\r\n  background: repeating-linear-gradient(\r\n    to right,\r\n    #ef4444 0px, #ef4444 4px,\r\n    #eab308 4px, #eab308 8px\r\n  ) !important;\r\n}\r\n\r\n/* Pit stop: white card with black \"P\" (dark mode default) */\r\n.flag-pitstop {\r\n  background: #e2e8f0 !important;\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.flag-pitstop::after {\r\n  content: 'P';\r\n  position: absolute;\r\n  font-size: 8px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #111;\r\n  font-family: sans-serif;\r\n}\r\n\r\nbody.light-theme .flag-pitstop {\r\n  background: #1e293b !important;\r\n}\r\nbody.light-theme .flag-pitstop::after {\r\n  color: #f8fafc;\r\n}\r\n\r\n/* ─── Collision badges ───────────────────────────────────────────────────── */\r\n\r\n.lap-events {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  align-items: center;\r\n}\r\n\r\n.collision-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: default;\r\n}\r\n\r\n.collision-badge.collision-damage {\r\n  background-color: rgba(239, 68, 68, 0.2);\r\n  color: #fca5a5;\r\n  border: 1px solid rgba(239, 68, 68, 0.3);\r\n}\r\n\r\n.collision-badge.collision-no-damage {\r\n  background-color: rgba(245, 158, 11, 0.15);\r\n  color: #fbbf24;\r\n  border: 1px solid rgba(245, 158, 11, 0.25);\r\n}\r\n\r\n/* ─── Ingame penalty badges ──────────────────────────────────────────────── */\r\n\r\n.ingame-penalty-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 7px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: default;\r\n  max-width: 140px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ingame-penalty-badge.pending {\r\n  background-color: rgba(239, 68, 68, 0.18);\r\n  color: #fca5a5;\r\n  border: 1px solid rgba(239, 68, 68, 0.28);\r\n}\r\n\r\n.ingame-penalty-badge.cleared {\r\n  background-color: rgba(148, 163, 184, 0.12);\r\n  color: #94a3b8;\r\n  border: 1px solid rgba(148, 163, 184, 0.18);\r\n}\r\n\r\n/* Mobile: same table layout as desktop, with horizontal scroll */\r\n@media (max-width: 768px) {\r\n  .race-results-modal {\r\n    max-width: 100%;\r\n    width: 100%;\r\n    max-height: 95vh;\r\n    margin: 8px;\r\n  }\r\n\r\n  .modal-header {\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .modal-title h2 {\r\n    font-size: 18px;\r\n    margin: 0 0 4px 0;\r\n  }\r\n\r\n  .session-info {\r\n    flex-direction: column;\r\n    gap: 2px;\r\n    font-size: 11px;\r\n  }\r\n\r\n  .track-name::before {\r\n    content: '📍 ';\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .server-name::before {\r\n    content: '🖥️ ';\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .results-table-container {\r\n    padding: 0;\r\n    overflow-x: auto;\r\n  }\r\n\r\n  .results-standings-table {\r\n    min-width: 600px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* ─── Light-theme overrides ──────────────────────────────────────────────────── */\r\n\r\nbody.light-theme .race-results-modal {\r\n  background-color: var(--surface);\r\n  border-color: var(--border);\r\n  box-shadow: var(--card-shadow);\r\n}\r\n\r\nbody.light-theme .modal-header {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .modal-title h2 {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .session-info {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .close-button {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .close-button:hover {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .penalty-summary-bar {\r\n  background-color: #e0f0ff;\r\n  border-bottom-color: var(--border);\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .results-standings-table thead {\r\n  background-color: var(--surface-strong);\r\n}\r\n\r\nbody.light-theme .results-standings-table th {\r\n  color: var(--muted-strong);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .results-standings-table tbody tr {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .results-standings-table tbody tr:hover {\r\n  background-color: rgba(15, 23, 42, 0.05);\r\n}\r\n\r\nbody.light-theme .results-standings-table td {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .driver-name {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .car-model {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .lap-best,\r\nbody.light-theme .lap-time,\r\nbody.light-theme .lap-count {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .gap {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .results-tab-bar {\r\n  background-color: var(--surface-strong);\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .results-tab {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .results-tab:hover {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .results-tab.active {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .race-results-modal .race-number {\r\n  background-color: var(--surface-strong);\r\n  color: var(--text);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .lap-details-modal {\r\n  background-color: var(--surface);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .lap-details-header {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .lap-details-header h3 {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .lap-details-header p {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .lap-details-table thead {\r\n  background-color: var(--surface-strong);\r\n}\r\n\r\nbody.light-theme .lap-details-table th,\r\nbody.light-theme .lap-details-table td {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .lap-details-table th {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .lap-details-table td {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .lap-details-table tbody tr:hover {\r\n  background-color: rgba(15, 23, 42, 0.04);\r\n}\r\n\r\nbody.light-theme .lap-details-empty {\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .no-penalty {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .progression-svg {\r\n  background-color: var(--surface-strong);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .progression-legend-item {\r\n  background-color: var(--surface-strong);\r\n  border-color: var(--border);\r\n  color: var(--muted-strong);\r\n}\r\n\r\nbody.light-theme .progression-legend-item:hover {\r\n  background-color: var(--border);\r\n}\r\n\r\nbody.light-theme .results-table-container::-webkit-scrollbar-track {\r\n  background-color: var(--surface-strong);\r\n}\r\n\r\nbody.light-theme .results-table-container::-webkit-scrollbar-thumb {\r\n  background-color: var(--border);\r\n}\r\n\r\nbody.light-theme .results-table-container::-webkit-scrollbar-thumb:hover {\r\n  background-color: var(--muted);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
